/**
 * Air Guide — reading progress, section nav spy
 */
(function () {
  if (window.__airGuideBooted) return;
  window.__airGuideBooted = true;

  function initProgress() {
    var bar = document.querySelector('[data-ag-progress]');
    if (!bar) return;
    function update() {
      var h = document.documentElement;
      var scroll = h.scrollTop || document.body.scrollTop;
      var height = h.scrollHeight - h.clientHeight;
      var pct = height > 0 ? (scroll / height) * 100 : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function getHeaderHeight() {
    var header = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    return !isNaN(header) && header > 0 ? header : 62;
  }

  function initSectionNav() {
    var wrap = document.querySelector('[data-ag-snav]');
    if (!wrap) return;
    var root = wrap.closest('[data-ag-snav-root]');
    var btns = wrap.querySelectorAll('[data-ag-snav-link]');
    if (!btns.length) return;
    var ids = [];
    btns.forEach(function (btn) {
      var href = btn.getAttribute('href') || '';
      var id = href.replace('#', '');
      if (id) ids.push(id);
    });
    var offset = parseInt(wrap.getAttribute('data-scroll-offset') || '140', 10);
    function getPinThreshold() {
      if (document.body.classList.contains('header-hidden')) return 0;
      return getHeaderHeight();
    }

    function updatePin() {
      if (!root) return;
      /* Pin only after the viewport has scrolled past the full nav block */
      var shouldPin = root.getBoundingClientRect().bottom <= getPinThreshold();
      wrap.classList.toggle('is-pinned', shouldPin);
      root.classList.toggle('is-pinned', shouldPin);
      if (shouldPin) {
        root.style.setProperty('--ag-snav-height', wrap.offsetHeight + 'px');
      } else {
        root.style.removeProperty('--ag-snav-height');
      }
    }

    function onScroll() {
      updatePin();
      var cur = '';
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - offset) cur = id;
      });
      btns.forEach(function (btn) {
        var href = (btn.getAttribute('href') || '').replace('#', '');
        btn.classList.toggle('is-active', href === cur);
      });
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - offset + 1;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updatePin, { passive: true });
    onScroll();
  }

  function boot() {
    initProgress();
    initSectionNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
